// ... existing imports ...
import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: 'Продукт',
    links: [
      { to: '/telegram-leads', label: 'Telegram заявки' },
      { to: '/ai-sales', label: 'AI рассыльщик' },
      { to: '/competitors', label: 'Перехват конкурентов' },
      { to: '/integrations', label: 'Интеграции' },
      { to: '/mass-mailing', label: 'Рассылка под ключ' },
      { to: '/leads-turnkey', label: 'Заявки под ключ' },
    ],
  },
  {
    title: 'Компания',
    links: [
      { to: '/partner', label: 'Партнёрам' },
    ],
  },
  {
    title: 'Правовая информация',
    links: [
      { to: '/privacy', label: 'Политика конфиденциальности' },
      { to: '/terms', label: 'Условия использования' },
      { to: '/offer', label: 'Оферта' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-10 py-12 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-5">
            <Link to="/" className="inline-flex items-center gap-2">
              <span className="w-8 h-8 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-flashlight-fill text-background-50 text-lg"></i>
              </span>
              <span className="font-display font-extrabold text-[22px] tracking-tightest text-background-50">
                AIGAM
              </span>
            </Link>
            <p className="mt-5 text-[14.5px] text-background-50/60 leading-relaxed max-w-sm">
              ИИ-продавец, который сам находит клиентов в Telegram и назначает встречи. Платформа для B2B-команд.
            </p>

          </div>

          {footerLinks.map((group) => (
            <div key={group.title} className="lg:col-span-2">
              <div className="text-[12px] font-semibold uppercase tracking-wider text-background-50/40">
                {group.title}
              </div>
              <ul className="mt-4 space-y-3">
                {group.links.map((link: any) => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link
                        to={link.to}
                        className="text-[14px] text-background-50/75 hover:text-primary-400 transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-[14px] text-background-50/75 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-3">
            <div className="text-[12px] font-semibold uppercase tracking-wider text-background-50/40">
              Связаться
            </div>
            <ul className="mt-4 space-y-3 text-[14px] text-background-50/75">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                info@aigam.ru
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-telegram-line text-primary-400"></i>
                @anna_aigam
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                Пн–Пт, 10:00–19:00 МСК
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-[13px] text-background-50/50">
          <div>© {new Date().getFullYear()} AIGAM. Все права защищены.</div>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-background-50 transition-colors">Политика конфиденциальности</Link>
            <Link to="/terms" className="hover:text-background-50 transition-colors">Условия использования</Link>
            <Link to="/offer" className="hover:text-background-50 transition-colors">Оферта</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}